module.exports = __webpack_public_path__ + "img/img13.cfb74825.png";